import React from 'react'
import ProductCheckInTypeContainer from './ProductCheckInTypeContainer'

const ProductSelectModal = ({
  isShow,
  onClose,
  onProductSelect,
  serviceId,
  searchText,
  onSearchChange,
}) => {
  if (!isShow) return null

  const handleProductSelect = (product) => {
    onProductSelect(product)
    onClose()
  }

  return (
    <div>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />

      <div className="fixed inset-0 z-50 flex items-start justify-center pt-16 px-4 pb-20 overflow-y-auto">
        <div
          className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-xl font-semibold text-gray-900">
              Select Product
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-6">
            <ProductCheckInTypeContainer
              onProductSelect={handleProductSelect}
              serviceId={serviceId}
              searchText={searchText}
              onSearchChange={onSearchChange}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductSelectModal
